export class EditabilityBasedOnProcessStatus {
  internalRoles: boolean = false;
  technicianRole: boolean = false;
  customerRole: boolean = false;
}
